export default __webpack_public_path__ + "static/media/egisWhiteLogo.b3baf68e.png";